import {
  ChangeDetectionStrategy,
  Component,
  Input,
  inject,
} from '@angular/core';
import { Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { faWilson } from '@awesome.me/kit-d87edcad8c/icons/kit/custom';

@Component({
  selector: 'wilson-version-update',
  templateUrl: './version-update.component.html',
  styleUrls: ['./version-update.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class VersionUpdateComponent {
  private modalCtrl = inject(ModalController);
  private router = inject(Router);

  faWilson = faWilson;

  @Input() updateRequired = false;
  @Input() storeUrl!: string;

  dismiss() {
    this.modalCtrl.dismiss();
    this.router.navigate(['/tabs/home']);
  }
}
